
import { defineComponent } from 'vue';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '@/firebase/init';

export default defineComponent({
  name: 'ForgotPasswordPage',
  data() {
    return {
      email: '' as string,
      errMsg: '' as string,
      sentMsg: '' as string
    };
  },
  methods: {
    async sendResetEmail() {
      if (this.email.trim() == '') {
        this.errMsg = 'Email cannot be empty';
        return;
      }
      try {
        // Only need to call this function,
        // Confirm pass is not needed as we would need to parse through the email to obtain oobCode for verification
        // And firebase just gives premade link to reset password
        await sendPasswordResetEmail(auth, this.email);
      } catch (e) {
        // Dont do anything, we dont want to expose any secrets
      } finally {
        this.sentMsg =
          'Email has been sent, please allow for 5 minutes before retrying';
      }
    }
  }
});
